export default "__VITE_ASSET__5e3bcbee__"